import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import CustomButton from "../Form/Button";
import {currencyFormat} from "../../utils/masks";
import {cancelImport, importDataQuotex} from "../../services/Trading";
import messageTypes from "../../constants/MessagesTypes";
import {toast} from "react-toastify";
import ConfirmDeleteModal from "../ConfirmDeleteModal";
import CircularProgressWithLabel from "../CircularProgressWithLabel";
import {useTranslation} from "react-i18next";
import {
    TradingNewFormWrap,
    TradingFormCard,
    ButtonContainer,
    ImportSummaryPanel,
    ImportSummaryStat,
    ImportSummaryStatHero,
    ImportStatIconTrades,
    ImportStatIconProfit,
    ImportStatIconBalance,
    ImportStatMain,
    ImportStatLabel,
    ImportStatValue,
    ImportStatValueHero,
    ImportProgressPanel,
    ImportProgressIcon,
    ImportProgressHeading,
    ImportProgressRingWrap,
    ImportProgressFootnote,
} from "../../pages/Trading/Import/styles";
import {StrategyEmptyState} from "../../pages/Strategy/styles";

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const importBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

export default function QuotexCSV({fileCSV}) {
    const [progress, setProgress] = React.useState(0);
    const [itemsFile, setItemsFile] = useState(null);
    const [importId, setImportId] = useState(null);
    const [valueFile, setValueFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [importConfirmOpen, setImportConfirmOpen] = useState(false);
    const {coinType, amount} = useSelector((state) => state.BankReducer);
    const fileReader = new FileReader();
    const history = useHistory();
    const { t } = useTranslation();

    const parseCSV = (text) => {
        const result = {
            header: [],
            data: []
        };

        const [header, ...content] = text.split('\n');
        result.header = header.split(',');
        const maxCols = result.header.length;

        content.forEach((item) => {
            result.data.push(item.split(',').slice(0, maxCols));
        });

        return result;
    };

    async function importStartFile(indexStart = 0, importIdResponse = null) {

        try {
            setLoading(true);
            var qtdeMaxImport = 10;
            var indexEnd = indexStart + qtdeMaxImport;
            const newProgress = indexStart / (itemsFile.length - 1) * 100;
            setProgress(newProgress > 100 ? 100 : newProgress);

            var data = {
                importId: importIdResponse,
                qtdeItems: itemsFile.length,
                value: valueFile,
                items: itemsFile.slice(indexStart, indexEnd)
            };

            const formData = new FormData();
            formData.append('data', JSON.stringify(data));

            const response = await importDataQuotex(formData);
            importIdResponse = response.data && response.data.importId ? response.data.importId : importIdResponse;
            if (!importId) {
                setImportId(importIdResponse);
            }

            if (indexStart < itemsFile.length - 1) {
                importStartFile(indexStart + data.items.length, importIdResponse);
            } else {
                setProgress(100);
                toast.success(messageTypes.SUCCESS_IMPORT);
                setTimeout(() => {
                    history.push('/trading');
                }, 1000);
            }
        } catch (e) {

            try {
                await cancelImport(importId);
                toast.error(messageTypes.ERROR_IMPORT);
            } catch (e) {
                toast.error(messageTypes.ERROR_IMPORT);
            }
        }
    }

    useEffect(() => {
        if (!fileCSV) {
            return;
        }

        fileReader.onload = function (event) {
            const csvOutput = event.target.result;
            const result = parseCSV(csvOutput);
            setItemsFile(result.data);
        };

        fileReader.readAsText(fileCSV);
    }, [fileCSV]);

    useEffect(() => {
        if (!itemsFile) {
            return;
        }

        let addValueBank = 0;
        for (let index = 0; index < itemsFile.length - 1; index++) {
            for (let i = 0; i < itemsFile[index].length; i++) {
                itemsFile[index][i] = (itemsFile[index][i]).replaceAll("\"", "");
            }
            const profitPrejudice = parseFloat(itemsFile[index][9]) - parseFloat(itemsFile[index][8]);
            addValueBank = addValueBank + profitPrejudice;
        }

        setValueFile(addValueBank);
    }, [itemsFile]);

    return (
        <>
        <TradingNewFormWrap>
            <TradingFormCard>
                {itemsFile && itemsFile.length ?
                    <>
                        <ImportSummaryPanel>
                            <ImportSummaryStat>
                                <ImportStatIconTrades aria-hidden="true">
                                    <i className="fas fa-clipboard-list"/>
                                </ImportStatIconTrades>
                                <ImportStatMain>
                                    <ImportStatLabel>{t('traging_import_tradings')}</ImportStatLabel>
                                </ImportStatMain>
                                <ImportStatValue>
                                    {itemsFile && itemsFile.length - 1 > 0 ? itemsFile.length - 1 : ''}
                                </ImportStatValue>
                            </ImportSummaryStat>
                            <ImportSummaryStat>
                                <ImportStatIconProfit aria-hidden="true">
                                    <i className="fas fa-chart-line"/>
                                </ImportStatIconProfit>
                                <ImportStatMain>
                                    <ImportStatLabel>{t('traging_import_tradings_value')}</ImportStatLabel>
                                </ImportStatMain>
                                <ImportStatValue>
                                    {coinType} {currencyFormat(valueFile)}
                                </ImportStatValue>
                            </ImportSummaryStat>
                            <ImportSummaryStatHero>
                                <ImportStatIconBalance aria-hidden="true">
                                    <i className="fas fa-wallet"/>
                                </ImportStatIconBalance>
                                <ImportStatMain>
                                    <ImportStatLabel>{t('traging_import_bank_balance')}</ImportStatLabel>
                                </ImportStatMain>
                                <ImportStatValueHero>
                                    {coinType} {currencyFormat(amount + valueFile)}
                                </ImportStatValueHero>
                            </ImportSummaryStatHero>
                        </ImportSummaryPanel>
                        {!loading ? (
                            <ButtonContainer>
                                <Link to="/trading" style={{ textDecoration: 'none' }}>
                                    <CustomButton
                                        variant="outlined"
                                        className="btn btn-secondary font-weight-bold text-capitalize mobile-button"
                                        style={backBtnStyle}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                        }}
                                    >
                                        {t('btn_back')}
                                    </CustomButton>
                                </Link>
                                <CustomButton
                                    loading={loading}
                                    onClick={() => setImportConfirmOpen(true)}
                                    className="btn btn-primary font-weight-bold text-capitalize mobile-button"
                                    style={importBtnStyle}
                                    onMouseEnter={(e) => {
                                        if (!loading) {
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                    }}
                                >
                                    {t('traging_import_start')}
                                </CustomButton>
                            </ButtonContainer>
                        ) : (
                            <ImportProgressPanel>
                                <ImportProgressIcon aria-hidden="true">
                                    <i className="fas fa-cloud-upload-alt"/>
                                </ImportProgressIcon>
                                <ImportProgressHeading>{t('traging_import_start_text')}</ImportProgressHeading>
                                <ImportProgressRingWrap>
                                    <CircularProgressWithLabel
                                        value={progress}
                                        size={88}
                                        thickness={3.6}
                                        ringColor="#f29205"
                                    />
                                </ImportProgressRingWrap>
                                <ImportProgressFootnote>{t('traging_import_progress_hint')}</ImportProgressFootnote>
                            </ImportProgressPanel>
                        )}
                    </> :
                    <StrategyEmptyState style={{ padding: '48px 20px' }}>
                        <i className="fas fa-file-csv" aria-hidden="true"/>
                        <p>{t('alert_register_not_found')}</p>
                    </StrategyEmptyState>
                }
            </TradingFormCard>
        </TradingNewFormWrap>
        <ConfirmDeleteModal
            isOpen={importConfirmOpen}
            onClose={() => setImportConfirmOpen(false)}
            onConfirm={() => {
                setImportConfirmOpen(false);
                importStartFile();
            }}
            variant="warning"
            title={t('traging_import_alert_start_title')}
            message={t('traging_import_alert_start_text')}
            showNotice={false}
            cancelLabel={t('traging_import_alert_start_cancel')}
            confirmLabel={t('traging_import_alert_start_confirm')}
        />
        </>
    );
}
